import React, { useEffect, useState } from 'react'
import AxiosInstance from '../../../Helper/AxiosInstance'
import { PageHeader, TableWrap, EmptyState } from '../../../Shared/DashboardUI'

export default function DirectMember() {
    const [data, setData] = useState([])
    const fetchData = async () => {
        try {
            const response = await AxiosInstance.get('/report?type=directmember')
            if (response.status === 1) { setData(response.data) }
        } catch (err) {

        }
    }
    useEffect(() => { fetchData() }, [])
    return (<>
        <PageHeader title="Direct Member" />
        <TableWrap>
            <thead>
                <tr>
                    <th>#</th><th>User Id</th><th>DOJ</th><th>DOA</th>
                    <th>Daily Business</th><th>Total Business</th><th>Status</th>
                </tr>
            </thead>
            <tbody>
                {(data || []).length === 0 ? (
                    <tr><td colSpan="7"><EmptyState /></td></tr>
                ) : (data || []).map((tr, ind) => (
                    <tr key={tr.regno || ind}>
                        <td>{(ind + 1).toString().padStart(2, 0)}</td>
                        <td>{tr.regno}</td>
                        <td>{tr.doj}</td>
                        <td>{tr.activedate}</td>
                        <td>{tr.dailybussiness}</td>
                        <td>{tr.totbusiness}</td>
                        <td>{tr.PaidUnpaid}</td>
                    </tr>
                ))}
            </tbody>
        </TableWrap>
    </>)
}
